import { render, staticRenderFns } from "./RiskProblem.vue?vue&type=template&id=e0b8e33a&scoped=true&"
import script from "./RiskProblem.vue?vue&type=script&lang=js&"
export * from "./RiskProblem.vue?vue&type=script&lang=js&"
import style0 from "./RiskProblem.vue?vue&type=style&index=0&id=e0b8e33a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b8e33a",
  null
  
)

export default component.exports